module.exports = __webpack_public_path__ + "img/expediente_cientifico_glifosato_web.c6c20a38.png";